import React from 'react';
import { Route } from '@/navigation/Route';
import { ProducerProductScreen } from './screens/list';
import { ProducerProductDetailScreen } from './screens/detail';

export const PRODUCER_PRODUCT_ROUTES = {
  itself: '/support/producer-product',
  detail: '/support/producer-product/:id/detail',
};

export const ProducerProductNavigation = (): JSX.Element => (
  <>
    <Route
      exact
      path={PRODUCER_PRODUCT_ROUTES.itself}
      component={ProducerProductScreen}
      isPrivateRoute
    />
    <Route
      exact
      path={PRODUCER_PRODUCT_ROUTES.detail}
      component={ProducerProductDetailScreen}
      isPrivateRoute
    />
  </>
);
